'use client';

// Research-in-Workspace (E1) — the creation-time consent toggle. Rendered in
// BOTH creation surfaces (ResearchConfig inside CreateResearchDialog, and
// GuidedResearchCreation); hidden entirely when the session has no eligible
// filing target (no active workspace, or not mounted read_write). Default ON —
// when a workspace is active, filing into it is the expected outcome.

import * as React from 'react';
import { useTranslations } from 'next-intl';
import { useWorkspaceFilingTarget } from '@/features/workspaces/filingTarget';

interface FileIntoWorkspaceToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export function FileIntoWorkspaceToggle({ checked, onChange }: FileIntoWorkspaceToggleProps) {
  const t = useTranslations('research');
  const target = useWorkspaceFilingTarget();
  if (!target) return null;

  return (
    <div className="rounded-md border border-border/40 bg-surface px-3 py-2.5">
      <label className="flex items-start gap-2 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-border text-accent focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        />
        <span className="flex flex-col">
          <span className="text-sm font-medium text-foreground">
            {t('fileIntoWorkspaceToggle.fileInto', { name: target.name })}
          </span>
          <span className="text-xs text-muted-foreground">
            {t('fileIntoWorkspaceToggle.runsInYourArea')}
          </span>
        </span>
      </label>
    </div>
  );
}
